import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";

const STATI = [
  { v: "nuova", l: "Nuova" },
  { v: "vista", l: "Vista" },
  { v: "contattato", l: "Contattato" },
  { v: "documentazione_inviata", l: "Doc. inviata" },
  { v: "in_trattativa", l: "In trattativa" },
  { v: "chiusa_positiva", l: "Chiusa +" },
  { v: "chiusa_negativa", l: "Chiusa −" },
];

const TIPI = [
  { v: "all", l: "Tutti i tipi" },
  { v: "contatto_agenzia", l: "Contatto agenzia" },
  { v: "richiesta_documentazione", l: "Richiesta documentazione" },
];

const tipoLabel = (t) => t === "contatto_agenzia" ? "Contatto agenzia" : "Richiesta doc.";
const tipoBadge = (t) => t === "contatto_agenzia" ? "badge-pronto" : "badge-criticita";

const fmtDT = (iso) => iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export default function RichiesteDocumentazione() {
  const [items, setItems] = useState([]);
  const [stats, setStats] = useState(null);
  const [filter, setFilter] = useState("all");
  const [tipoFilter, setTipoFilter] = useState("all");

  const load = () => {
    const params = new URLSearchParams();
    if (filter !== "all") params.set("status", filter);
    if (tipoFilter !== "all") params.set("tipo", tipoFilter);
    return api.get(`/document-requests${params.toString() ? `?${params.toString()}` : ""}`).then((r) => setItems(r.data));
  };
  useEffect(() => { load(); api.get("/document-requests/stats").then((r) => setStats(r.data)); }, [filter, tipoFilter]);

  const setStato = async (id, v) => {
    try { await api.patch(`/document-requests/${id}`, { status: v }); load(); toast.success("Aggiornato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const del = async (id, nome) => {
    if (!window.confirm(`Elimina richiesta di ${nome}?`)) return;
    try { await api.delete(`/document-requests/${id}`); load(); toast.success("Eliminata"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="admin-doc-requests">
      <div className="label-uppercase">Rete</div>
      <h1 className="font-serif text-4xl mt-2 mb-8">Richieste dalla scheda immobile</h1>

      {stats && (
        <>
          <div className="grid md:grid-cols-4 gap-4 mb-4">
            <div className="bg-white border border-[#E6E4E0] p-5"><div className="label-uppercase text-[#5C5657]">Totali</div><div className="font-serif text-4xl mt-2">{stats.total}</div></div>
            <div className="bg-white border border-[#E6E4E0] p-5"><div className="label-uppercase text-[#5C5657]">Contatti agenzia</div><div className="font-serif text-4xl mt-2 text-[#245A2E]">{stats.per_tipo?.contatto_agenzia || 0}</div></div>
            <div className="bg-white border border-[#E6E4E0] p-5"><div className="label-uppercase text-[#5C5657]">Richieste doc.</div><div className="font-serif text-4xl mt-2 text-[#91590F]">{stats.per_tipo?.richiesta_documentazione || 0}</div></div>
            <div className="bg-white border border-[#E6E4E0] p-5"><div className="label-uppercase text-[#5C5657]">Chiuse +</div><div className="font-serif text-4xl mt-2 text-[#245A2E]">{stats.per_status?.chiusa_positiva || 0}</div></div>
          </div>
          <div className="grid md:grid-cols-3 gap-4 mb-8">
            <div className="bg-white border border-[#E6E4E0] p-5"><div className="label-uppercase text-[#5C5657]">Nuove</div><div className="font-serif text-3xl mt-1 text-[#7D2E3F]">{stats.per_status?.nuova || 0}</div></div>
            <div className="bg-white border border-[#E6E4E0] p-5"><div className="label-uppercase text-[#5C5657]">In trattativa</div><div className="font-serif text-3xl mt-1">{stats.per_status?.in_trattativa || 0}</div></div>
            <div className="bg-white border border-[#E6E4E0] p-5"><div className="label-uppercase text-[#5C5657]">Contattato</div><div className="font-serif text-3xl mt-1">{stats.per_status?.contattato || 0}</div></div>
          </div>
        </>
      )}

      {stats?.per_agency?.length > 0 && (
        <div className="bg-white border border-[#E6E4E0] p-6 mb-8">
          <div className="label-uppercase text-[#7D2E3F] mb-4">Conversioni per agenzia</div>
          <table className="w-full text-sm">
            <thead><tr className="border-b border-[#E6E4E0]"><th className="text-left py-2 label-uppercase">Agenzia</th><th className="text-right py-2 label-uppercase">Totali</th><th className="text-right py-2 label-uppercase">Chiuse +</th><th className="text-right py-2 label-uppercase">Conversione</th></tr></thead>
            <tbody>
              {stats.per_agency.map((a) => (
                <tr key={a.agency_id} className="border-b border-[#E6E4E0]/40">
                  <td className="py-2">{a.name}</td>
                  <td className="text-right">{a.total}</td>
                  <td className="text-right">{a.chiuse_positiva}</td>
                  <td className="text-right font-serif">{a.conversion}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="flex flex-wrap gap-4 mb-4 items-center">
        <div className="flex gap-2 items-center">
          <span className="label-uppercase text-[#5C5657] text-xs">Tipo:</span>
          {TIPI.map((t) => (
            <button key={t.v} onClick={() => setTipoFilter(t.v)} data-testid={`filter-tipo-${t.v}`} className={`text-xs label-uppercase px-3 py-1 border ${tipoFilter === t.v ? "border-[#7D2E3F] text-[#7D2E3F]" : "border-[#E6E4E0] text-[#5C5657]"}`}>{t.l}</button>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        <span className="label-uppercase text-[#5C5657] text-xs self-center mr-1">Stato:</span>
        <button onClick={() => setFilter("all")} className={`text-xs label-uppercase px-3 py-1 border ${filter === "all" ? "border-[#7D2E3F] text-[#7D2E3F]" : "border-[#E6E4E0] text-[#5C5657]"}`}>Tutte</button>
        {STATI.map((s) => (
          <button key={s.v} onClick={() => setFilter(s.v)} className={`text-xs label-uppercase px-3 py-1 border ${filter === s.v ? "border-[#7D2E3F] text-[#7D2E3F]" : "border-[#E6E4E0] text-[#5C5657]"}`}>{s.l}</button>
        ))}
      </div>

      <table className="admin-table w-full bg-white border border-[#E6E4E0]">
        <thead><tr><th>Tipo</th><th>Richiedente</th><th>Immobile</th><th>Agenzia</th><th>Ricevuta</th><th>Stato</th><th></th></tr></thead>
        <tbody>
          {items.map((d) => (
            <tr key={d.id} data-testid={`docreq-row-${d.id}`}>
              <td><span className={`badge-stamp text-[10px] ${tipoBadge(d.tipo)}`}>{tipoLabel(d.tipo)}</span></td>
              <td><div className="font-medium" data-testid={`docreq-nome-${d.id}`}>{d.nome}</div><div className="text-xs text-[#5C5657]">{d.email} · {d.telefono}</div></td>
              <td className="text-xs">{d.property_titolo || "—"}</td>
              <td className="text-xs">{d.agency?.name || "—"}</td>
              <td className="text-xs whitespace-nowrap">{fmtDT(d.created_at)}</td>
              <td>
                <select data-testid={`docreq-status-${d.id}`} value={d.status} onChange={(e) => setStato(d.id, e.target.value)} className="text-xs border border-[#E6E4E0] px-2 py-1 bg-white">
                  {STATI.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}
                </select>
              </td>
              <td className="text-right"><button onClick={() => del(d.id, d.nome)} className="text-xs label-uppercase text-[#B3261E]">Elimina</button></td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan="7" className="text-center py-8 text-[#5C5657]">Nessuna richiesta</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
